import React, { useState } from 'react';
import { TextField, Button, Grid, Box, FormHelperText, Snackbar, Alert } from '@mui/material';
import { branchCreate } from '../../../Services/Services';

const AddBranchForm = ({setBranches,setOpenAddModal}) => {
  const [branchDetails, setBranchDetails] = useState({
    branch_name: '',
    branch_address: '',
    branch_contact: '',
  });

  const [contactNoError, setContactNoError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBranchDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleContactNoChange = (e) => {
    const { value } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setBranchDetails((prev) => ({
        ...prev,
        branch_contact: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (branchDetails.branch_contact.length !== 10) {
      setContactNoError('Branch Contact No must be exactly 10 digits');
      return;
    }

    setContactNoError('');

    const formData = new FormData();
    formData.append('branch_name', branchDetails.branch_name);
    formData.append('branch_address', branchDetails.branch_address);
    formData.append('branch_contact', branchDetails.branch_contact);

    try {
     const response = await branchCreate(formData);
setBranches(response)
setOpenAddModal(false)
      setSnackbar({
        open: true,
        message: 'Branch created successfully!',
        severity: 'success',
      });

      // Reset form
      setBranchDetails({
        branch_name: '',
        branch_address: '',
        branch_contact: '',
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Failed to create branch. Please try again.',
        severity: 'error',
      });
    }
  };

  return (
    <Box className="form-container-branch">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Branch Name"
              variant="outlined"
              name="branch_name"
              value={branchDetails.branch_name}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Branch Address"
              variant="outlined"
              name="branch_address"
              value={branchDetails.branch_address}
              onChange={handleChange}
              multiline
              rows={2}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Branch Contact No"
              variant="outlined"
              name="branch_contact"
              value={branchDetails.branch_contact}
              onChange={handleContactNoChange}
              required
              type="tel"
              inputProps={{ maxLength: 10 }}
              error={!!contactNoError}
            />
            {contactNoError && (
              <FormHelperText error>{contactNoError}</FormHelperText>
            )}
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Add Branch
            </Button>
          </Grid>

        </Grid>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
    top: "80px !important",
  }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddBranchForm;
